// extracted by mini-css-extract-plugin
module.exports = {"caption":"PhuHuynhChildList_caption__9hOyD","list_horizontal":"PhuHuynhChildList_list_horizontal__2yIxA","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__1WBuP"};